import moment from 'moment';

export const DATE_FORMAT_WITH_YEAR = 'D MMM YYYY';
export const DATE_FORMAT_WITHOUT_YEAR = 'D MMM';

const checkIfCurrentYear = (date: string | number | Date) => {
  const currentYear = moment().year();
  const dateObj = moment(date);
  const isCurrentYear = dateObj.year() === currentYear;

  return isCurrentYear;
};

const formatAMPM = (date: Date) => {
  let hours = date.getHours();
  let minutes: string | number = date.getMinutes();
  let seconds: string | number = date.getSeconds();
  const ampm = hours >= 12 ? 'pm' : 'am';

  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  const strTime = `${hours}:${minutes}:${seconds} ${ampm}`;

  return strTime;
};

// if current year, dont show year in date string
export const formatDate = (date: string | number | Date): string => {
  const dateObj = moment(date);
  const isCurrentYear = checkIfCurrentYear(date);

  return isCurrentYear
    ? dateObj.format(DATE_FORMAT_WITHOUT_YEAR)
    : dateObj.format(DATE_FORMAT_WITH_YEAR);
};

export const formatDateWithTime = (
  dateParam: string | number | Date,
): string => {
  const isCurrentYear = checkIfCurrentYear(dateParam);

  const date = new Date(dateParam);
  const shortMonth = date.toLocaleString('default', { month: 'short' });

  return `${date.getDate()} ${shortMonth}${
    isCurrentYear ? '' : ` ${date.getFullYear()}`
  }, ${formatAMPM(date)}`;
};
